angular.module("vgresiduos").controller("DisposalIntegrationCtrl", [
	"$rootScope",
	"$scope",
	"$q",
	"httpService",
	"mtrSystemService",
	"accountService",
	function ($rootScope, $scope, $q, httpService, mtrSystemService, accountService) {
		"use strict";

		$scope.labels = $rootScope.labels;

		this.$onInit = function () {
			if (!$scope.isCurrentStageReview() && !$scope.hasIntegrations() && !$scope.isOriginHistoryThatCantUseMtr()) {
				calculateSystemsToIntegrate().then(function (mtrSystemsToIntegrate) {
					$scope.ctrl.destinationModel.ExternalSystems = mtrSystemsToIntegrate;

					updateSlip();
					$rootScope.$broadcast(Vgr.constants.evtClientExternalSystemChanged, $scope.ctrl.destinationModel.Id);
				});
			} else if ($scope.hasIntegrations()) {
				$scope.updateSlip($scope.stepsEnum.D, $scope.ctrl.destinationModel.Manifests[0].SourceDescription);
			}
		};

		function calculateSystemsToIntegrate() {
			const deferred = $q.defer();

			const client = accountService.getCurrentClient();
			const destinatorCity = $scope.ctrl.readOnlyModel.Destinator.City;
			const dto = {
				organizationUnitId: client.id,
				destinatorStateId: destinatorCity ? destinatorCity.State.Id : null
			};

			httpService.postDTOToServiceV2(mtrSystemService.calculateMtrSystemsToIntegrate, dto).then(
				function (mtrSystemsToIntegrate) {
					const mtrSystems = [];

					for (const index in mtrSystemsToIntegrate) {
						mtrSystems.push({
							SourceId: mtrSystemsToIntegrate[index].source.id,
							SourceDescription: mtrSystemsToIntegrate[index].source.description,
							Selected: true
						});
					}

					deferred.resolve(mtrSystems);
				},
				function () {
					deferred.resolve([]);
				}
			);

			return deferred.promise;
		}

		function updateSlip() {
			if (hasAnyExternalSystemChecked()) {
				$scope.updateSlip($scope.stepsEnum.D, getSlipDescription());
			} else {
				$scope.updateSlip($scope.stepsEnum.D, null);
			}
		}

		function hasAnyExternalSystemChecked() {
			return $scope.ctrl.destinationModel.ExternalSystems &&
				$scope.ctrl.destinationModel.ExternalSystems.find((system) => system.Selected)
				? true
				: false;
		}

		function getSlipDescription() {
			let slipDescription = "";
			const externalSystems = $scope.ctrl.destinationModel.ExternalSystems;

			for (const i in externalSystems) {
				if (externalSystems[i].Selected) {
					slipDescription += externalSystems[i].SourceDescription + "\n";
				}
			}

			return slipDescription;
		}

		$scope.systemChange = function () {
			updateSlip();
			$rootScope.$broadcast(Vgr.constants.evtClientExternalSystemChanged, $scope.ctrl.destinationModel.Id);
		};
	}
]);
